export interface IListFilters {
  view: string;
}

export interface IListView<TRow> {
  value: string;
  label: string;
  keeps: (row: TRow) => boolean;
}

export const parseListFilters = (
  search: Record<string, unknown>,
  fallback: string,
): IListFilters => ({
  view: typeof search.view === 'string' ? search.view : fallback,
});

export const listFiltersToSearch = (filters: IListFilters): Record<string, string> => ({
  view: filters.view,
});

export const narrowRows = <TRow>(
  rows: readonly TRow[],
  views: readonly IListView<TRow>[],
  filters: IListFilters,
): TRow[] => {
  const view = views.find((entry) => entry.value === filters.view);
  return view ? rows.filter((row) => view.keeps(row)) : [...rows];
};

// Returns undefined on purpose when the loaded page is not the whole list: a count from rows in hand would understate the segment.
export const exactCounts = <TRow>(
  rows: readonly TRow[],
  views: readonly IListView<TRow>[],
  total: number | null | undefined,
): Record<string, number> | undefined => {
  if (typeof total === 'number' && total > rows.length) return undefined;
  return Object.fromEntries(
    views.map((view) => [view.value, rows.filter((row) => view.keeps(row)).length]),
  );
};
